<template>
    <purchase-sector title="구매수량">
        <div class="purchase-amount">
            <purchase-amount-form v-model="form" @input="emit" />
            <v-divider />
            <purchase-amount-view v-model="form" />
            <v-divider />
            <purchase-amount-noti />
        </div>
    </purchase-sector>
</template>

<script>
import { initNshopOrder } from "@/store/nshop";

import PurchaseAmountForm from "./purchase-amount-form.vue";
import PurchaseAmountNoti from "./purchase-amount-noti.vue";
import PurchaseAmountView from "./purchase-amount-view.vue";
import PurchaseSector from "./purchase-sector.vue";

/** @typedef {import('@/store/nshop').NshopOrder} NshopOrder */

export default {
    components: {
        PurchaseAmountForm,
        PurchaseAmountNoti,
        PurchaseAmountView,
        PurchaseSector,
    },
    props: {
        /** @type {import('vue').PropType<NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    data: () => ({
        form: initNshopOrder(),
    }),
    computed: {},
    methods: {
        sync() {
            this.form = initNshopOrder(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.purchase-amount {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>
